import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { wellFiltersAtom } from './atoms';
import { applyWellFilters } from './well-filters';
import type { GroupedWell } from './utils';

/**
 * The crossings the section shows: what the cut returned, narrowed by the rail's
 * well filters.
 *
 * One hook rather than a filter at each call site, because the chart, the rail's
 * count and the colour rule have to agree on which wells are on the section — a
 * crossing plotted but not counted is a bug the user reads as data loss.
 *
 * Filtering here rather than in the request is deliberate: which wells the line
 * crosses is geometry, so a filter changes what is shown rather than what is
 * calculated. That keeps the PRD's rule — display switches never recalculate — true
 * of filters too.
 *
 * @param {Array} wells - Every crossing the cut returned.
 * @return {Array} The crossings that survive the filters.
 */
export const useSectionWells = (wells: GroupedWell[]): GroupedWell[] => {
  const filters = useAtomValue(wellFiltersAtom);
  return useMemo(() => applyWellFilters(wells, filters), [wells, filters]);
};
